const directive = {};

directive.disable = function (el, config) {

  const blur = config.blur;
  const dim = config.dim;
  const disabled = config.disabled;

  el.style.transition = 'all .2s linear';

  el.style.filter = disabled && blur ? 'blur(1.5px)' : 'none';
  el.style.opacity = disabled && dim ? 0.4 : 1;
  el.style.pointerEvents = disabled ? 'none' : 'auto';
};

directive.mounted = function (el, binding) {
  directive.disable(el, binding.value);
};

directive.updated = function (el, binding) {
  directive.disable(el, binding.value);
};

export default directive;
